import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgRadioCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "nonzero",
		d: "M10 5.833A4.168 4.168 0 0 0 5.833 10c0 2.3 1.867 4.167 4.167 4.167S14.167 12.3 14.167 10 12.3 5.833 10 5.833zm0-4.166A8.336 8.336 0 0 0 1.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667zm0 15A6.665 6.665 0 0 1 3.333 10 6.665 6.665 0 0 1 10 3.333 6.665 6.665 0 0 1 16.667 10 6.665 6.665 0 0 1 10 16.667z"
	})
});
export default SvgRadioCircle;
